import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

export const Container = styled.div`
  flex: 1;
  margin-top: 96px;
  max-width: 280px;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 4px;
  position: sticky;
  top: 96px;
`;

export const Item = styled.button`
  --icon-border-color: transparent;
  --icon-background-color: ${COLORS.white};
  --icon-color: ${COLORS.systemDark200};
  --text-color: ${COLORS.systemSky200};

  display: flex;
  align-items: center;
  gap: 12px;
  background: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    --icon-border-color: ${COLORS.systemDark200};
    --text-color: ${COLORS.systemSky300};
  }

  &.active {
    --icon-border-color: transparent;
    --icon-background-color: ${COLORS.systemDark300};
    --icon-color: ${COLORS.white};
    --text-color: ${COLORS.systemDark300};
  }
`;

export const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: var(--icon-background-color);
  border: 1px solid var(--icon-border-color);
  transition: border-color 0.25s ease;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const StyledText = styled.p`
  color: var(--text-color);
  font-size: 16px;
  line-height: 24px;
  transition: color 0.25s ease;

  &.bold {
    font-weight: 600;
  }
`;

export const StyledIcon = styled(Icon)`
  color: var(--icon-color);
`;

export const Divider = styled.div`
  width: 1px;
  height: 28px;
  background-color: ${COLORS.systemDark100};
  margin-left: 20px;
`;

export const ErrorIcon = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${COLORS.systemFlame200};
`;
